// extracted by mini-css-extract-plugin
export default {"box":"checkout_box__bgrtK"};